const locate = (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage ||
  window.navigator.browserLanguage ||
  'en'

export default {locate,language:locate.substr(0, 2)}




// WEBPACK FOOTER //
// ./src/utils/DetectBrowserLanguage.js